import { RecommendPage } from './RecommendPage'
import { withRecommendPage } from './withRecommendPage'

const ConnectedRecommendPage = withRecommendPage(RecommendPage)

export { ConnectedRecommendPage as RecommendPage }
